import clsx from "clsx";
import { useEffect, useRef } from "react";
import { ConnectorTreeList } from "./ConnectorTreeList";
import { UploadTreeList } from "./UploadTreeList";
import { fileListFileTypeAtom } from "../../state/misc.state";
import { selectedFileAtom } from "../../state";
import { useAtom, useAtomValue } from "jotai";
import { SourceType } from "@/entities/DataAssociation/File.model";

export function FileListV2() {
    const [fileType, setFileType] = useAtom(fileListFileTypeAtom);
    const { data: selectedFile } = useAtomValue(selectedFileAtom);
    const hasInitialized = useRef(false);

    useEffect(() => {
        if (selectedFile && !hasInitialized.current) {
            hasInitialized.current = true;
            if (selectedFile.sourceType === SourceType.UploadedFile) {
                setFileType("uploads");
            }
        }
    }, [selectedFile, setFileType]);

    return (
        <div
            className={clsx(
                "flex h-full flex-col",
                "overflow-hidden px-2.5 pt-4",
            )}
        >
            <div className="flex h-full flex-col">
                <div className="shrink-0 pb-6">
                    <div className="flex items-center gap-2">
                        <button
                            className={clsx(
                                "no-styles body-micro w-full cursor-pointer rounded py-2",
                                fileType === "connectors"
                                    ? "bg-selected"
                                    : "bg-slate-900/20",
                            )}
                            onClick={() => setFileType("connectors")}
                        >
                            Connectors
                        </button>
                        <button
                            className={clsx(
                                "no-styles body-micro w-full cursor-pointer rounded py-2",
                                fileType === "uploads"
                                    ? "bg-selected"
                                    : "bg-slate-900/20",
                            )}
                            onClick={() => setFileType("uploads")}
                        >
                            Uploads
                        </button>
                    </div>
                </div>
                <div
                    className={clsx(
                        "custom-scrollbar hide-scrollbar min-h-0 flex-1 overflow-y-auto",
                    )}
                >
                    {fileType === "connectors" && <ConnectorTreeList />}
                    {fileType === "uploads" && <UploadTreeList />}
                </div>
            </div>
        </div>
    );
}
